
import { useState, useMemo } from 'react';
import { useGame } from '../contexts/GameContext';

export const useCareerPathSelection = () => {
  const { 
    selectedRole,
    careerLevel,
    careerPath
  } = useGame();
  
  const [showPathSelection, setShowPathSelection] = useState(false);
  
  // Check if the current level can have a career path selection
  const canSelectPath = useMemo(() => {
    if (!selectedRole) return false;
    
    const currentLevelData = selectedRole.careerPath.find(path => path.level === careerLevel);
    return currentLevelData?.pathOptions && currentLevelData.pathOptions.length > 0 && careerPath === 'Standard';
  }, [selectedRole, careerLevel, careerPath]);

  return {
    showPathSelection,
    setShowPathSelection,
    canSelectPath
  };
};
